<div style="background-color: #9657D6;" class="py-2">
    <div class="container text-center">
        <p class="text-white mb-0 fst-italic">
          @if (isSpanishPage) {
            Este contenido fue {{ isUpdated ? 'actualizado' : 'revisado' }} por última vez en {{ dateText }}
          } @else {
            This content was last {{ isUpdated ? 'updated' : 'reviewed' }} {{ dateText }}
          }
        </p>
    </div>
</div>
